import { T, useT } from "@repo/transifex";
import { ReportCard, ReportPriceRow, ReportRow } from "~/components/report";

import { type TransactionSummaryData } from "./types";

type TransactionSummarySectionProps = {
  data: TransactionSummaryData;
};

export const TransactionSummarySection = ({
  data
}: TransactionSummarySectionProps) => {
  const t = useT();

  return (
    <ReportCard title={<T _str="Transaction Summary" />}>
      <ReportRow
        label={t("Number of transactions")}
        value={data.transactions}
      />
      <ReportRow
        label={t("Number of products sold")}
        value={data.productsSold}
      />
      <ReportPriceRow
        label={t("Average Transaction Value")}
        value={data.avgTransactionValue}
        currency={data.currency}
      />
      <ReportRow
        label={t("Discounted Transactions")}
        value={data.discountedTransactions}
      />
      <ReportRow
        label={t("Refunded Transactions")}
        value={data.refundedTransactions}
      />
      <ReportRow
        label={t("Voided Transactions")}
        value={data.voidedTransactions}
      />
    </ReportCard>
  );
};
